import React, { useState, useEffect } from "react";
import "./index.css";

const Quiz = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://the-trivia-api.com/v2/questions")
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        setLoading(false);
      });
  }, []);

  const handleAnswerClick = (isCorrect) => {
    if (isCorrect) {
      setScore(score + 1);
    }
    setCurrentQuestion(currentQuestion + 1);
  };

  const handleBackClick = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  if (loading) return <h2>Loading...</h2>;

  return (
    <div className="app-container">
      {/* ✅ Header will always be visible */}
      <header className="quiz-header">
        <h1>Fun Quiz 🎉</h1>
      </header>

      {currentQuestion >= questions.length ? (
        // ✅ Final Score Screen with Header
        <h2 className="final-score">🚀Final Score: {score}</h2>
      ) : (
        // ✅ Quiz Question Section
        <div className="quiz-container">
          <h3 className="question-counter">
            Question {currentQuestion + 1} of {questions.length}
          </h3>
          <h2 className="quiz-question">
            {questions[currentQuestion].question.text}
          </h2>
          <div className="quiz-options">
            {[
              ...questions[currentQuestion].incorrectAnswers,
              questions[currentQuestion].correctAnswer,
            ]
              .sort(() => Math.random() - 0.5)
              .map((option, index) => (
                <button
                  key={index}
                  onClick={() =>
                    handleAnswerClick(
                      option === questions[currentQuestion].correctAnswer
                    )
                  }
                >
                  {option}
                </button>
              ))}
          </div>
          <div className="btn-container">
            <button
              className="back-btn"
              onClick={handleBackClick}
              disabled={currentQuestion === 0}
            >
              Back
            </button>
            <button
              className="next-btn"
              onClick={() => setCurrentQuestion(currentQuestion + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz;
